// extracted by mini-css-extract-plugin
export var cardLayout = "card-layout-module--card-layout--8060c";
export var cardLayout2 = "card-layout-module--card-layout--2--680d4";
export var cardLayout3 = "card-layout-module--card-layout--3--7f5a4";
export var cardLayout4 = "card-layout-module--card-layout--4--c5b8b";
export var cardLayout__item = "card-layout-module--card-layout__item--c19d8";
export var mt0 = "card-layout-module--mt-0--40654";
export var mt1 = "card-layout-module--mt-1--8d591";
export var mt2 = "card-layout-module--mt-2--f9b37";
export var mt3 = "card-layout-module--mt-3--abac0";
export var mt4 = "card-layout-module--mt-4--c58ee";
export var mt5 = "card-layout-module--mt-5--d42b0";
export var mt6 = "card-layout-module--mt-6--9cdc3";